/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Check = ({
  color = 'white',
  bgColor = 'forest',
  height = 20,
  ...props
}) => {
  return (
    <svg width={20} height={height} viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20h20V0H0v20z"
        sx={{ fill: bgColor }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.494 10.55l3.3 3.385L16.506 5 18 6.533 7.794 17h-.001L3 12.085l1.494-1.534z"
        sx={{ fill: color }}
      />
    </svg>
  )
}

Check.propTypes = {
  bgColor: string,
  color: string,
  height: number,
}

export default Check
